import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';

interface Props {
    label: string;
    isRequired: boolean;
    attributes: { [key: string]: string };
}

const List = ({ label, isRequired, attributes }: Props) => {
    const ListTag = attributes?.['$ordered'] === 'true' ? 'ol' : 'ul';

    return (
        <div data-testid="component-preview-list">
            <PreviewComponentLabel labelText={label} isRequired={isRequired} />
            <ListTag>
                <li>List Item 1</li>
                <li>List Item 2</li>
                <li>List Item 3</li>
            </ListTag>
        </div>
    );
};

export default List;
